import { createSlice } from "@reduxjs/toolkit"

const configSlice = createSlice({
    name: "config",
    initialState: {
        name: null,
        contentFilter: null,
    },
    reducers: {
        getConfig() { },
        getConfigValue() { },
        saveConfig() { },
        backupConfig() { },
        restoreConfig() { },
        testAIConnection() { },
        getAiUsage() { },
        testHubspotConnection() { },
        testIntuitConnection() { },
        getWhatsAppStatus() { },
        getWhatsAppQr() { },
        startWhatsAppSession() { },
        logoutWhatsAppSession() { },
        testWhatsAppMessage() { },
        setConfig(state, action) {
            const { config } = action.payload;
            return state = { ...state, ...config };
        },
        setContentFilter(state, action) {
            state.contentFilter = action.payload;
        },
    }
});

export const { getConfig, getConfigValue, saveConfig, backupConfig, restoreConfig, testAIConnection, getAiUsage, testHubspotConnection, testIntuitConnection, getWhatsAppStatus, getWhatsAppQr, startWhatsAppSession, logoutWhatsAppSession, testWhatsAppMessage, setConfig, setContentFilter } = configSlice.actions;
export default configSlice.reducer;
